export default __webpack_public_path__ + "static/media/logo-prodcast.7309d43c.png";